import isEmailValid from '../modules/email-check';

const initialize = () => {
    const adminDeleteModal = document.getElementById('adminDeleteModal');
    adminDeleteModal.addEventListener('show.bs.modal', (event) => {
        const button = event.relatedTarget;
        const { email, csrf, action } = button.dataset;

        adminDeleteModal.querySelector('#adminDelete').setAttribute('action', action);
        adminDeleteModal.querySelector('#adminDelete [name="accesstoken"]').value = csrf;
        adminDeleteModal.querySelector('#admin').value = email;
    });

    const adminInviteCancelModal = document.getElementById('adminInviteCancelModal');
    adminInviteCancelModal.addEventListener('show.bs.modal', (event) => {
        const { action } = event.relatedTarget.dataset;

        adminInviteCancelModal.querySelector('#adminInviteCancel').setAttribute('action', action);
    });

    const inviteBtn = document.getElementById('inviteBtn');
    const newAdminInput = document.getElementById('newAdmin');
    newAdminInput.addEventListener('input', function () {
        if (isEmailValid(newAdminInput.value)) {
            inviteBtn.removeAttribute('disabled');
        } else {
            inviteBtn.setAttribute('disabled', 'disabled');
        }
    });
};

export default initialize;
